import * as pictlinkAdAction from "../action/PictlinkAdAction";

const state = {
    topPageAdList: null,
}

const getters = {
    topPageAdList(state){
        return state.topPageAdList
    }

}

const actions = {
    async getTopPageAdList({ commit }){
        const spaceId = await pictlinkAdAction.getPictlinkAdSpaceId('topPage')
        commit('setTopPageAdList', await pictlinkAdAction.fetchPictlinkAdList(spaceId));
    },
}

const mutations = {
    setTopPageAdList(state, topPageAdList) {
        state.topPageAdList = topPageAdList;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}